import React from 'react';
import { Play } from 'lucide-react';

/**
 * TutorialOferta - Página standalone para video tutorial
 * Muestra un video embebido sobre cómo pasar una oferta
 * Diseñado para ser enlazado desde correos electrónicos
 */
const TutorialOferta = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 flex items-center justify-center p-4 md:p-6">
      <div className="w-full max-w-6xl">
        {/* Contenedor principal con borde y backdrop */}
        <div className="bg-slate-800/50 backdrop-blur-xl rounded-2xl border border-slate-700/50 overflow-hidden">
          
          {/* Header con icono y título */}
          <div className="bg-gradient-to-r from-slate-800/80 to-slate-900/80 p-6 md:p-8 border-b border-slate-700/50">
            <div className="flex items-center gap-4 mb-3">
              <div className="bg-gradient-to-br from-amber-400 to-amber-600 p-3 rounded-xl">
                <Play className="w-6 h-6 text-slate-900" />
              </div>
              <h1 className="text-2xl md:text-3xl font-bold text-white">
                Tutorial: Cómo Pasar una Oferta
              </h1>
            </div>
            <p className="text-slate-400 text-sm md:text-base ml-16">
              A continuación tienes un vídeo tutorial donde se describe el paso a paso de pasar una oferta.
            </p>
          </div>

          {/* Contenedor del video con aspect ratio responsive */}
          <div className="p-4 md:p-6 lg:p-8">
            <div className="relative w-full" style={{ paddingBottom: '54.48%' }}>
              {/* 54.48% = (936/1718) * 100 para mantener aspect ratio original */}
              <video
                controls
                className="absolute top-0 left-0 w-full h-full rounded-lg shadow-2xl"
                style={{ 
                  backgroundColor: '#0f172a',
                  objectFit: 'contain'
                }}
              >
                <source 
                  src="https://creandohogares.online/videos_internos/tutorial-pasar-oferta.mp4" 
                  type="video/mp4" 
                />
                Tu navegador no soporta la reproducción de video. 
                <a 
                  href="https://creandohogares.online/videos_internos/tutorial-pasar-oferta.mp4"
                  className="text-amber-400 hover:text-amber-300 underline"
                >
                  Descarga el video aquí
                </a>
              </video>
            </div>

            {/* Nota informativa opcional */}
            <div className="mt-4 text-center">
              <p className="text-xs text-slate-500">
                💡 Puedes pausar, retroceder y avanzar el video según necesites
              </p>
            </div>
          </div>

        </div>

        {/* Footer minimalista con branding */}
        <div className="mt-6 text-center">
          <p className="text-slate-600 text-xs">
            RealtyBid © 2024 · Plataforma de Subastas Inmobiliarias
          </p>
        </div>
      </div>
    </div>
  );
};

export default TutorialOferta;